import { externalGet } from '../utils/api';

export default async function getCurrentCountryCode() {
  const res =  await externalGet('https://ipapi.co/json/');
  return res.country_calling_code || '+972' ;
}
